import { Link } from "@material-ui/core";
import React from "react";
import { Link as RouterLink } from "react-router-dom";

import { useAuth } from "../../../../features/auth/context";
import { useOrgSiteContext } from "../../../../hooks/useOrgSiteContext";

export function LinkToBoxesPage() {
    const {
        orgId: contextOrgId,
        siteId: contextSiteId,
        dealerId: contextDealerId,
    } = useOrgSiteContext("boxDetail");
    const {
        orgId: assignedOrgId,
        siteId: assignedSiteId,
        dealerId: assignedDealerId,
    } = useAuth();

    const orgId = contextOrgId || assignedOrgId;
    const siteId = contextSiteId || assignedSiteId;
    const dealerId = contextDealerId || assignedDealerId;

    const orgPath = orgId ? `/organizations/${orgId}` : "";
    const sitePath = siteId ? `/sites/${siteId}` : "";
    const dealerPath = dealerId ? `/dealers/${dealerId}` : "";
    const boxesPageUrl = dealerPath
        ? `${dealerPath}${orgPath}${sitePath}/boxes`
        : "/boxes";

    return (
        <Link component={RouterLink} to={boxesPageUrl}>
            Back to Boxes List
        </Link>
    );
}
